/**
 * Service labels per jurisdiction.
 *
 * Each jurisdiction gets its own file so adding a service is a small diff
 * that can be reviewed in isolation. Files are imported by `index.ts` which
 * exports a flat list (for dropdowns) and a per-jurisdiction map (for
 * cascading selects).
 *
 * Source: `compliance-services-config.json` on the VPS (legacy). The legacy
 * file is being retired — these TS files are the new single source.
 */

import type { ServiceLabel } from './types';

export const UAE_SERVICES: readonly ServiceLabel[] = [
  { key: 'VAT Returns',                   label: 'VAT Returns',                       jurisdiction: 'UAE' },
  { key: 'VAT Registration',              label: 'VAT Registration',                  jurisdiction: 'UAE' },
  { key: 'VAT Return Filing',             label: 'VAT Return Filing',                 jurisdiction: 'UAE' },
  { key: 'VAT De-registration',           label: 'VAT De-registration',               jurisdiction: 'UAE' },
  { key: 'Corporate Tax',                 label: 'Corporate Tax',                     jurisdiction: 'UAE' },
  { key: 'Corporate Tax Registration',    label: 'Corporate Tax Registration',        jurisdiction: 'UAE' },
  { key: 'Corporate Tax Return Filing',   label: 'Corporate Tax Return Filing',       jurisdiction: 'UAE' },
  { key: 'Corporate Tax De-registration', label: 'Corporate Tax De-registration',     jurisdiction: 'UAE' },
  { key: 'AML Compliance',                label: 'AML Compliance',                    jurisdiction: 'UAE' },
  { key: 'UBO Filing',                    label: 'UBO Filing',                        jurisdiction: 'UAE' },
  { key: 'Payroll / WPS',                 label: 'Payroll / WPS',                     jurisdiction: 'UAE' },
  { key: 'TRC',                           label: 'Tax Residency Certificate (TRC)',   jurisdiction: 'UAE' },
  { key: 'Accounts Filing',               label: 'Accounts filing to registration Authority', jurisdiction: 'UAE' },
  { key: 'Bank Account Opening',          label: 'Bank account opening',              jurisdiction: 'UAE' },
  { key: 'Custom Registration',           label: 'Custom Registration',               jurisdiction: 'UAE' },
  { key: 'Chamber of Commerce',           label: 'Chamber of commerce registration',  jurisdiction: 'UAE' },
  { key: 'Bookkeeping',                   label: 'Bookkeeping',                       jurisdiction: 'UAE' },
  { key: 'Other',                         label: 'Other',                             jurisdiction: 'UAE' },
] as const;